export default "__VITE_ASSET__CCya_Pry__"